import React, { useState } from "react";
import TextInput from "../../../../../components/TextInput";
import { toast } from "../../../../../components/toastNotification";
import Button from "../../../../../components/Button";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/solid";
import ConfirmBoxModal from "../../../../../components/ConfirmBoxModal";
import useAddEmployeeBilingual from "../hooks/useAddEmployeeBilingual";
import useGetEmployeeBilingual from "../hooks/useGetEmployeeBilingual";
import { useRecoilState } from "recoil";

import { addStateEmployeeBilingual } from "../atoms/atoms";
import MaterialTableTS from "../../../../../components/tables/MaterialTableTS";

interface EmployeeBilingualFormProps {
  isAdd: boolean;
  setIsAdd;
}

export const EmployeeBilingualForm: React.FC<EmployeeBilingualFormProps> = ({
  isAdd,
  setIsAdd,
}) => {
  //Hooks
  const AddEmployeeBilingual = useAddEmployeeBilingual();
  const { data: billingualData } = useGetEmployeeBilingual();
  //Recoils Call
  const [actionAddState, setActionAddState] = useRecoilState(
    addStateEmployeeBilingual
  );

  const [changed, setChanged] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [hasEmployeeBilingual, setHasEmployeeBilingual] = useState(false);
  const defaulValues = {
    bilingualId: 0,
    bilingualName: "",
    isActive: 0,
    createdBy: "",
    createdDate: "",
    modifiedBy: "",
    modifiedDate: "",
  };
  const [empBilingualNewData] = useState([defaulValues]);
  const [employeeBilingualExist, setemployeeBilingualExist] = useState(false);

  const handleAddBilingual = (SourceType, fieldName, inputvalue) => {
    setemployeeBilingualExist(false);
    inputvalue = inputvalue.trim();
    if (SourceType === "EmployeeBilingual") {
      if (fieldName === "bilingualName") {
        setChanged(true);
        const result = billingualData?.data.filter(
          (item) =>
            item.bilingualName?.toUpperCase() === inputvalue?.toUpperCase()
        )[0];
        if (result !== undefined) {
          setemployeeBilingualExist(true);
        } else {
          empBilingualNewData.map((x) => (x.bilingualName = inputvalue));
        }
        inputvalue === ""
          ? setHasEmployeeBilingual(false)
          : setHasEmployeeBilingual(true);
      }
    }
  };

  //save changes
  const handleSave = (empBilingualNewData) => {
    if (changed) {
      if (!employeeBilingualExist) {
        if (empBilingualNewData.filter((x) => x.bilingualName) !== "") {
          //call Insert
          AddEmployeeBilingual(empBilingualNewData);
          setActionAddState(!actionAddState);
          setOpenModal(false);
          setIsAdd(false);
        } else {
          toast.fire(
            "Saving Failed",
            "All required fields must be filled!",
            "error"
          );
          setOpenModal(false);
        }
      } else {
        toast.fire(
          "Saving Failed",
          "Employee Bilingual already exists!",
          "error"
        );
        setOpenModal(false);
      }
    } else {
      toast.fire("Saving Failed", "No Changes have been made", "warning");
      setOpenModal(false);
    }
  };

  // To define the value of align
  type MyColumn = {
    title: string;
    field?: string;
    align?: "center";
    render: (rowData: any) => JSX.Element;
  };
  const matColumns: MyColumn[] = [
    {
      title: "Employee Bilingual Name",
      field: "bilingualName",
      render: (rowData) => {
        return (
          <div className="grid-cols-3 grid ">
            <TextInput
              defaultValue={rowData.bilingualName}
              value={undefined}
              onChange={(inputdata) =>
                handleAddBilingual(
                  "EmployeeBilingual",
                  "bilingualName",
                  inputdata.target.value
                )
              }
            />
          </div>
        );
      },
    },
  ];
  return (
    <div className="">
      <div className="w-full">
        <ConfirmBoxModal
          ModalTitle="Add Employee Bilingual"
          qConfirmation=" Are you sure you want to add this?"
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          onClickFunction={() => {
            handleSave(empBilingualNewData);
          }}
          cancelButtonRef={undefined}
        />
        <div className=" px-3 border-l-2  border-primary box-shadow">
          <div className="flex items-center justify-between">
            <div className="text-base text-primary font-bold">
              Add New Employee Bilingual
            </div>
            <div className="flex items-center space-x-2 pt-2 pb-2">
              <Button
                className={`flex items-center shadow-md text-xs font-semibold text-white justify-left gap-x-1 rounded-full bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
              ${!hasEmployeeBilingual ? "opacity-50" : "opactiy-100"}`}
                disabled={!hasEmployeeBilingual}
                onClickFunction={() => setOpenModal(true)}
              >
                <CheckCircleIcon className="h-4 w-4" />
                <div className="text-xs3 font-normal self-center -mt-px">
                  Save
                </div>
              </Button>
              <Button
                className="flex items-center text-xs shadow-md font-semibold text-white justify-left gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1 "
                onClickFunction={() => {
                  setActionAddState(!actionAddState);
                  setIsAdd(false);
                }}
                disabled={undefined}
              >
                <XCircleIcon className="h-4 w-4" />
                <div className="text-xs3 font-normal self-center -mt-px">
                  Cancel
                </div>
              </Button>
            </div>
          </div>

          <div className=" h-0.5 w-full border-b-2 border-secondary "></div>

          <div className=" w-full py-2  ">
            <MaterialTableTS
              columns={matColumns}
              data={empBilingualNewData}
              paging={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeBilingualForm;
